import React, { useContext } from "react";
import RightSidebarTab from "./RightSidebarTab";
import RightSidebarButton from "./RightSidebarButton";
import RightSidebarUserInfo from "./RightSidebarUserInfo";
import { GlobalStateContext } from "../GlobalStates";
import RightSidebarList from "./RightSidebarList";
import ImpersonationBanner from "./ImpersonationBanner";
import { useLocation } from "react-router-dom";

const SidebarMenu = () => {
    const { toggleSidebar, setToggleSidebar, setCurrentPanel, auth } =
        useContext(GlobalStateContext);

    const closeSidebar = () => {
        document.body.classList.remove("no_overflow");
        setToggleSidebar(false);
    };

    const history = useLocation();
    const currentRoute = history.pathname;
    // React.useEffect(() => {
    //     currentRoute.substr(1, 4) === "user"
    //         ? setCurrentPanel("user")
    //         : setCurrentPanel("organ");
    // }, []);

    return (
        <div className={`right-sidebar-main  ${toggleSidebar && " show"}`}>
            <div
                className={`sidebar-backdrop ${toggleSidebar && " show"}`}
                onClick={closeSidebar}
            ></div>
            <div className="sidebar-con">
                <RightSidebarUserInfo />
                <ImpersonationBanner />
                <RightSidebarTab />
                <RightSidebarList closeSidebar={closeSidebar} />
                {auth.access_token && <RightSidebarButton />}
            </div>
        </div>
    );
};

export default SidebarMenu;
